<template>
  <div class="list" name="info">
    <el-card class="searchCard" shadow="never">
      <el-col>
        <el-form :inline="true" :model="search_machines">
          <el-form-item label="录入时间">
            <el-date-picker
              v-model="comeTime"
              type="daterange"
              align="left"
              @change="dateChange"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              clearable
              :picker-options="pickerOptions">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="机具编号">
            <el-input
              style="width:160px;"
              v-model="search_machines.FSn"
              auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="设备sn">
            <el-input
              style="width:160px;"
              v-model="search_machines.FPinpadSn"
              auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="厂家名称">
            <el-input
              style="width:150px;"
              v-model="search_machines.FIndustryName"
              auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="厂家型号">
            <el-input
              style="width:150px;"
              v-model="search_machines.FIndustryModel"
              auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="机具类型">
            <el-select
              style="width:150px;"
              v-model="search_machines.FPosType"
              placeholder=""
              clearable>
              <el-option label="全部" value=""></el-option>
              <el-option
                v-for="(item, index) in FPosTypeList"
                :key="index"
                :label="item.value"
                :value="item.key">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所属代理商/业务员">
            <el-input
              style="width:150px;"
              v-model="search_machines.FOperatorOrAgent"
              auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="分配状态">
            <el-select
              style="width:150px;"
              v-model="search_machines.FIsDistributed"
              placeholder=""
              clearable>
              <el-option label="全部" value=""></el-option>
              <el-option label="已分配" value="1"></el-option>
              <el-option label="未分配" value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <auth-button
              opt="search"
              :plain="true"
              icon="el-icon-search"
              @click.native="buttomSearch"
              :loading="machinesLoading"
              label="查询"></auth-button>
            <auth-button opt="batch_distribute" icon="el-icon-edit" @click.native="handleDistribute(null)" label="分配"></auth-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-card>
    <el-card class="tableCard" shadow="never">
      <!-- 列表模块 -->
      <el-table
        stripe
        style="width:100%"
        align="center"
        v-loading="machinesLoading"
        :data="machines_list"
        :header-cell-style="{background:'#FAFAFA'}"
        @sort-change="tableSortChange"
        @selection-change="changeSelectFun"
      >
        <el-table-column
          type="selection"
          width="55"
          :selectable="selectable"
        >
        </el-table-column>
        <el-table-column
          prop="fSn"
          label="机具编号"
          align="center">
        </el-table-column>
        <el-table-column
          prop="fCreateTime"
          label="录入时间"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="fPinpadSn"
          label="设备SN"
          align="center">
        </el-table-column>
        <el-table-column
          prop="fIndustryName"
          label="厂家名称"
          align="center">
        </el-table-column>
        <el-table-column
          prop="fIndustryModel"
          label="厂家型号"
          align="center">
        </el-table-column>
        <el-table-column
          prop="fLeshuaModel"
          label="乐刷型号"
          align="center">
        </el-table-column>
        <el-table-column
          prop="fPresentAgent"
          label="直属代理商/业务员"
          align="center">
        </el-table-column>
        <el-table-column
          prop="fPosType"
          label="机具类型"
          :formatter="formatPosType"
          align="center">
        </el-table-column>
        <el-table-column
          prop="fIsDistributed"
          label="分配状态"
          :formatter="formatDistributed"
          align="center">
        </el-table-column>
        <el-table-column
          label="操作"
          width="250"
          align="center"
          fixed="right"
          :context="_self">
          <template slot-scope="scope">
            <auth-button
              opt="distribute"
              type="text"
              v-if="scope.row.fIsDistributed === 0"
              label="分配"
              @click.native="handleDistribute(scope.row.fSn)"></auth-button>
            <auth-button
              opt="cancel_distribute"
              type="text"
              v-if="scope.row.fIsDistributed === 1"
              :loading="bindingBasic.bindingLoading"
              label="取消分配"
              @click.native="handleCancelDistribute(scope.row,scope.$index,machines_list)"></auth-button>
            <auth-button
              opt="bind"
              type="text"
              label="绑定"
              @click.native="handleSingleBinding(scope.row,scope.$index,machines_list)"></auth-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <el-col :span="24" class="btm-action">
      <el-pagination
        v-if="paginations.total>0"
        class="pagination"
        :page-sizes="paginations.pageSizes"
        :page-size="paginations.pageSize"
        :layout="paginations.layout"
        :total="paginations.total"
        :pageNum="paginations.pageNum"
        @current-change="onChangeCurrentPage">
      </el-pagination>
    </el-col>

    <!-- 分配界面 -->
    <el-dialog title="分配界面" :visible.sync="dialogDistribute" size="mini" width="25%">
      <el-row >
        <el-form
          label-width="100px"
          ref="distributeBasic"
          :model="distributeBasic"
          :rules="rule_data">
          <el-form-item label="机具编号：" v-if="distributeBasic.isSingle">
            <el-input
              v-model="distributeBasic.sns"
              style="width: 80%"
              :disabled="distributeBasic.distributeDisabled"
            ></el-input>
          </el-form-item>
          <el-form-item label="已选择机具编号：" v-if="!distributeBasic.isSingle">
            <el-input
              type="textarea"
              :rows="3"
              style="width: 80%"
              :disabled="distributeBasic.distributeDisabled"
              v-model="distributeBasic.sns">
            </el-input>
          </el-form-item>
          <el-form-item label=" 已选择机具数量：" v-if="!distributeBasic.isSingle">
            <el-input
              v-model="distributeBasic.num"
              style="width: 80%"
              :disabled="distributeBasic.distributeDisabled"
            ></el-input>
          </el-form-item>
          <el-form-item label="所属代理商/业务员编号：" prop="agentId">
            <el-input
              v-model="distributeBasic.agentId"
              placeholder="请输入所属代理商/业务员编号"
              style="width: 80%"></el-input>
          </el-form-item>

        </el-form>
      </el-row>
      <span slot="footer" class="dialog-footer" style="width:100%">
        <el-button icon="el-icon-save" type="primary" @click="submitDistribute('distributeBasic')" :loading="distributeBasic.distributeLoading">分配</el-button>
        <el-button @click="dialogDistribute = false" >取消</el-button>
      </span>
    </el-dialog>

    <!-- 机具绑定(单个) -->
    <el-dialog title="机具绑定" :visible.sync="dialogSingleBinding" size="small" width="25%">
      <el-row >
        <el-form
          label-width="100px"
          ref="bindingBasic"
          :model="bindingBasic"
          :rules="rule_data">
          <el-form-item label="机具编号：">
            <el-input v-model="bindingBasic.sn" style="width: 80%" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="所属代理商/业务员：">
            <el-input v-model="bindingBasic.agentId" style="width: 80%" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="商户编号：" prop="fMerchantId" >
            <el-input v-model="bindingBasic.merchantId" style="width: 80%" placeholder="请输入您要绑定的商户编号"></el-input>
          </el-form-item>
        </el-form>
      </el-row>
      <span slot="footer" class="dialog-footer" style="width:100%">
        <el-button icon="el-icon-save" type="primary" @click="submitSingleBinding('bindingBasic')" :loading="bindingBasic.bindingLoading">绑定</el-button>
        <el-button @click="dialogSingleBinding = false" >取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import qs from 'qs'
// export default {RecordJs};
import { listMachinesDistribute, machinePosType, checkMachineDistribute, machineDistribute, machineCancelDistribute, machineBind } from '@/api/machine'
export default {
  data () {
    return {
      comeTime: '',
      machines_list: [],
      group_list: [],
      bank_list: [],
      pro_list: [],
      city_list: [],
      area_list: [],
      bank_pro_list: [],
      bank_city_list: [],
      branch_list: [],
      effect_privilege_level_list: [],
      areas: [],
      citys: [],
      data: [],
      pos: [],
      scan: [],
      dataParam: {},
      domain: 'https://pos.yeahka.com/',
      picDomain: 'https://pic.yeahka.com/',
      table_type: 'sale',
      form_type: 'sale',
      qrCodeNum: '',
      staffsNum: '',
      roleName: '',
      machinesLoading: false,
      dialogVisible: false,
      dialogDistribute: false,
      dialogBinding: false,
      dialogSingleBinding: false,
      addLoading: false,
      authLoading: false,
      picLoading: false,
      zfztDisabledInput: true,
      gzztDisabledInput: true,
      groupIdDisabledInput: false,
      disabledInput: false,
      editLoading: false,
      holderDisabledInput: false,
      headShopMerchantIdInput: false,
      publicsignalAppidGZItem: true,
      publicsignalAppidItem: true,
      publicsignalAuthorizationDirectoryItem: true,
      dialogDisabled: false,
      settleDialogDisabled: false,
      settleToDisabled: false,
      nopassReason: false,
      editable: false,
      selectedMachineSns: [],
      distributeBasic: {
        agentId: '',
        isSingle: true,
        sns: '',
        num: '',
        distributeDisabled: true,
        distributeLoading: false
      },
      bindingBasic: {
        sn: '',
        agentId: '',
        merchantId: '',
        bindingLoading: false
      },
      currentAgentId: '',
      totalAmountCount: {
        qrCodeCount: '',
        bindCount: '',
        noBindCount: ''
      },
      picLoadingArr: [{ idcardFront: false }, { idcardBack: false },
        { bankcardFront: false },
        { businessLicenseC: false },
        { doorPhoto: false },
        { cashierDesk: false },
        { businessInside: false },
        { nonLegSettleAuth: false },
        { nonLegIdcardFront: false },
        { nonLegIdcardBack: false },
        { protocolPage: false },
        { taxRegCert: false },
        { organizationCode: false },
        { leaseContract: false }],
      // 修改界面数据
      other: {
        mccType: '',
        gzzt: '', // 关注主体
        zfzt: '' // 支付主体
      },
      fRate: '',
      userId: '',
      userName: '',
      rule_data: {
        agentId: [
          { required: true, message: '请输入所属代理商/业务员编号', trigger: 'blur' }
        ],
        merchantId: [
          { required: true, message: '请输入商户编号', trigger: 'blur' }
        ]
      },
      // 搜索表单信息
      search_machines: {
        startTime: '',
        endTime: '',
        FSn: '',
        FPinpadId: '',
        FPinpadSn: '',
        FIndustryName: '',
        FIndustryModel: '',
        FPosType: '',
        FOperatorOrAgent: '',
        FIsDistributed: ''
      },
      FPosTypeList: '',
      licenseChecked: false,
      pics: {
        idcardFront: '',
        idcardBack: '',
        bankcardFront: '',
        businessLicenseC: '',
        doorPhoto: '',
        cashierDesk: '',
        businessInside: '',
        protocolPage: '',
        nonLegSettleAuth: '',
        nonLegIdcardFront: '',
        nonLegIdcardBack: '',
        taxRegCert: '',
        organizationCode: '',
        leaseContract: '',
        // 上面是绝对路径，存储到数据库，下面是url，显示到页面
        idcardFrontUrl: '',
        idcardBackUrl: '',
        bankcardFrontUrl: '',
        businessLicenseCUrl: '',
        doorPhotoUrl: '',
        cashierDeskUrl: '',
        businessInsideUrl: '',
        protocolPageUrl: '',
        nonLegSettleAuthUrl: '',
        nonLegIdcardFrontUrl: '',
        nonLegIdcardBackUrl: '',
        taxRegCertUrl: '',
        organizationCodeUrl: '',
        leaseContractUrl: ''
      },

      // 需要给分页组件传的信息
      paginations: {
        pageNum: 1,
        total: 0,
        pageSize: 10,
        pageSizes: [10],
        layout: 'total, prev, pager, next, jumper'
      },
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      }
    }
  },
  mounted () {
    this.setDefaultDate()
    this.getList()
    this.loadPosTypeList()
  },
  methods: {
    dateChange (value) {
      if (value !== null) {
        value[0] = value[0].getFullYear() + '-' + (((value[0].getMonth() + 1) < 10) ? ('0' + (value[0].getMonth() + 1)) : (value[0].getMonth() + 1)) + '-' + ((value[0].getDate() < 10) ? ('0' + value[0].getDate()) : (value[0].getDate())) + ' 00:00:00'
        value[1] = value[1].getFullYear() + '-' + (((value[1].getMonth() + 1) < 10) ? ('0' + (value[1].getMonth() + 1)) : (value[1].getMonth() + 1)) + '-' + ((value[1].getDate() < 10) ? ('0' + value[1].getDate()) : (value[1].getDate())) + ' 23:59:59'
        this.search_machines.FStartTime = value[0]
        this.search_machines.FEndTime = value[1]
      } else {
        this.search_machines.FStartTime = ''
        this.search_machines.FEndTime = ''
      }
    },
    setDefaultDate () {
      const end = new Date()
      const start = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
      this.comeTime = [start, end]
      this.dateChange(this.comeTime)
    },
    selectable (row, index) {
      // 已分配的不能选中
      return row.fIsDistributed !== 1
    },
    changeSelectFun (val) {
      var sns = []
      for (var i = 0; i < val.length; i++) {
        sns[i] = val[i].fSn
      }
      this.selectedMachineSns = sns
    },
    /**
       * 改变当前页事件
       * @param  {number} page 当前页码
       */
    onChangeCurrentPage (page) {
      var totalCount = this.qrCodeNum
      // var pageSize = this.machines_list.length;
      this.search_machines.pageNo = page
      // this.search_machines.pageSize = pageSize;
      this.search_machines.Count = totalCount
      // this.search_machines.pageSize = size;
      this.getList()
    },
    /**
       * 改变每页显示数量事件
       * @param  {number} size 当前每页显示数量
       */
    onChangePageSize (size) {
      console.log(this)
      var totalCount = this.qrCodeNum
      var pageNo = this.paginations1.pageNum
      this.search_machines.pageSize = size
      this.search_machines.pageNo = pageNo
      this.search_machines.Count = totalCount
      this.onSearch()
    },
    formatSearch (search) {
      var data = Object.assign({}, search)
      for (var s in data) {
        if (!data[s] && data[s] !== 0) {
          delete data[s]
        } else {
          data[s] = this.$jquery.trim(data[s])
        }
      }
      return data
    },
    // 点击搜索按钮事件
    onSearch () {
      this.machinesLoading = true
      // this.search_machines.pageNo = 1;
      this.getList()
    },
    /* 点击查询按钮事件 */
    buttomSearch () {
      // 当点击查询时，显示第一页
      this.search_machines.pageNo = 1
      // 让页码数回归到1
      this.paginations.total = 0
      this.onSearch()
    },
    getList () {
      this.machinesLoading = true
      this.selectedMachineSns = []
      var data = this.formatSearch(this.search_machines)
      data = qs.stringify(data)
      listMachinesDistribute(data).then(data => {
        if (parseInt(data.error_code) !== 0) {
          this.$message({
            showClose: true,
            message: data.error_msg,
            type: 'error'
          })
          this.machinesLoading = false
        } else {
          this.machinesLoading = false
          this.paginations.total = data.totalCount
          this.machines_list = data.list
          this.qrCodeNum = data.totalCount
        }
      })
    },
    loadPosTypeList () {
      machinePosType(null).then((data) => {
        if (parseInt(data.error_code) === 0) {
          this.FPosTypeList = data.data
        }
      })
    },
    tableSortChange (val) {
      this.getList()
    },
    formatDistributed (item) {
      return item.fIsDistributed === 0 ? '未分配' : '已分配'
    },
    formatPosType (item) {
      var str
      switch (item.fPosType) {
        case '02': str = '传统pos'; break
        case '03': str = 'mpos'; break
        case '04': str = '智能pos'; break
        case '06': str = '扫码盒子'; break
        case '07': str = '云闪付终端'; break
        case '11': str = '刷脸设备'; break
        default: str = ''
      }
      return str
    },
    /* 机具分配 */
    handleDistribute (code) {
      this.distributeBasic.agentId = ''
      if (code) {
        this.distributeBasic.isSingle = true
        this.distributeBasic.sns = code
      } else {
        if (this.selectedMachineSns.length === 0) {
          this.$message({
            showClose: true,
            message: '请选择要分配的机具！',
            type: 'error'
          })
          return
        }
        this.distributeBasic.isSingle = false
        this.distributeBasic.num = this.selectedMachineSns.length
        var sns = this.selectedMachineSns
        var snsStr = ''
        for (var i = 0; i < sns.length; i++) {
          snsStr += sns[i]
          snsStr += ' , '
        }
        this.distributeBasic.sns = snsStr.substring(0, snsStr.length - 3)
      }
      this.dialogDistribute = true
    },
    submitDistribute (distributeBasic) {
      if (this.distributeBasic.agentId === '') {
        this.$message({
          showClose: true,
          message: '请输入所属代理商/业务员编号',
          type: 'error'
        })
        return
      }

      var checkData = {
        agentId: this.distributeBasic.agentId
      }
      var agentName
      checkData = qs.stringify(checkData)
      checkMachineDistribute(checkData).then(checkData => {
        if (parseInt(checkData.error_code) === 0) {
          agentName = checkData.agentName

          this.$confirm('确认将机具[' + this.distributeBasic.sns + ']分配给' + agentName + '?', '确定登出', {}).then(() => {
            this.distributeBasic.distributeLoading = true
            var sns = this.distributeBasic.sns.split(' , ')
            var data = {
              sns: sns,
              agentId: this.distributeBasic.agentId
            }
            data = qs.stringify(data)
            machineDistribute(data).then(data => {
              this.distributeBasic.distributeLoading = false
              if (parseInt(data.error_code) === 0) {
                this.$message({
                  message: data.error_msg,
                  type: 'success'
                })
                this.dialogDistribute = false
                this.getList()
              } else {
                this.$message({
                  message: data.error_msg,
                  type: 'error'
                })
              }
            })
          })
        } else {
          this.$message({
            message: checkData.error_msg,
            type: 'error'
          })
        }
      })
    },
    /* 机具取消分配 */
    handleCancelDistribute (row, index, scope) {
      this.$confirm(this.$createElement('div', null, [this.$createElement('p', null, '取消分配后，你可重新分配该机具'), this.$createElement('p', null, '机具编号:' + row.fSn)]), '确认取消分配以下机具吗？', {}).then(() => {
        this.distributeBasic.distributeLoading = true
        var data = {
          sn: row.fSn
        }
        data = qs.stringify(data)
        machineCancelDistribute(data).then(data => {
          this.distributeBasic.distributeLoading = false
          if (parseInt(data.error_code) === 0) {
            this.$message({
              message: data.error_msg,
              type: 'success'
            })
            this.getList()
          } else {
            this.$message({
              message: data.error_msg,
              type: 'error'
            })
          }
        })
      })
    },
    /* 机具绑定（单个） */
    handleSingleBinding (row, index, scope) {
      this.dialogSingleBinding = true
      this.bindingBasic.sn = row.fSn
      this.bindingBasic.agentId = row.fPresentAgent
      this.bindingBasic.merchantId = ''
    },
    submitSingleBinding (bindingBasic) {
      var mId = this.bindingBasic.merchantId
      if (mId === '') {
        this.$message({
          showClose: true,
          message: '请输入商户编号',
          type: 'error'
        })
        return
      }
      this.bindingBasic.bindingLoading = true
      var data = {
        sn: this.bindingBasic.sn,
        merchantId: this.bindingBasic.merchantId,
        bindType: 1// 绑定时传1
      }
      data = qs.stringify(data)
      machineBind(data).then((data) => {
        this.bindingBasic.bindingLoading = false
        if (parseInt(data.error_code) === 0) {
          this.$message({
            message: data.error_msg,
            type: 'success'
          })
          this.dialogSingleBinding = false
          this.getList()
        } else {
          this.$message({
            message: data.error_msg,
            type: 'error'
          })
        }
      })
    }
  }
}

</script>
<style rel="stylesheet/scss" lang="scss" scoped>
  .btm-action {
    margin: 20px 0;
    text-align: center;
  }

  .pagination {
    display: inline-block;
  }
  .list{
    padding-left: 16px;
  }
  /deep/ .el-form-item__label{
    text-align: left;
  }
</style>
